import { render, staticRenderFns } from "./OperaDistributeServeWindow.vue?vue&type=template&id=2e548470&scoped=true&"
import script from "./OperaDistributeServeWindow.vue?vue&type=script&lang=js&"
export * from "./OperaDistributeServeWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaDistributeServeWindow.vue?vue&type=style&index=0&id=2e548470&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e548470",
  null
  
)

export default component.exports